import * as React from 'react';

function IconNavigationDirectionSmall(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6667 9V5C10.6667 4.73478 10.5613 4.48043 10.3738 4.29289C10.1862 4.10536 9.93187 4 9.66666 4C9.40144 4 9.14709 4.10536 8.95955 4.29289C8.77201 4.48043 8.66666 4.73478 8.66666 5V11C8.66666 11.7956 8.35059 12.5587 7.78798 13.1213C7.22537 13.6839 6.46231 14 5.66666 14C4.87101 14 4.10795 13.6839 3.54534 13.1213C2.98273 12.5587 2.66666 11.7956 2.66666 11V5L2.16666 5.5L1.16666 4.5L3.66666 2L6.16666 4.5L5.16666 5.5L4.66666 5V11C4.66666 11.2652 4.77201 11.5196 4.95955 11.7071C5.14709 11.8946 5.40144 12 5.66666 12C5.93187 12 6.18623 11.8946 6.37376 11.7071C6.5613 11.5196 6.66666 11.2652 6.66666 11V5C6.66666 4.20435 6.98273 3.44129 7.54534 2.87868C8.10795 2.31607 8.87101 2 9.66666 2C10.4623 2 11.2254 2.31607 11.788 2.87868C12.3506 3.44129 12.6667 4.20435 12.6667 5V9H10.6667ZM13.6667 12C13.6667 13.1046 12.7712 14 11.6667 14C10.5621 14 9.66666 13.1046 9.66666 12C9.66666 10.8954 10.5621 10 11.6667 10C12.7712 10 13.6667 10.8954 13.6667 12Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconNavigationDirectionSmall;
